import { FC } from 'react';
import { PureDrawer, IPureDrawerProps } from '@base/lib/PureDrawer';
import cn from 'classnames';
import styles from './index.module.less';

type IDrawerProps = IPureDrawerProps;

export const Drawer: FC<IDrawerProps> = props => {
    const {
        className,
        isHash = false,
        ...rest
    } = props;

    return (
        <PureDrawer
            className={cn(className, styles.drawer)}
            isHash={isHash}
            {...rest}
        />
    )
};
